var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.publicStudyLists),function(item,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"6"}},[_c('v-card',{attrs:{"flat":"","to":{ name: 'StudyListDetail', params: { id: item.id.toString() } }}},[_c('v-card-title',{domProps:{"textContent":_vm._s(item.name)}}),_c('v-card-subtitle',{domProps:{"textContent":_vm._s(
            ((item.item_count) + " " + (_vm.pluralize(
              item.item_count,
              'term',
              'terms'
            )))
          )}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }